import { useCompanySettings, logoSrc, compactLogoSrc } from '@/lib/companySettings';

export function Logo({ size = 'md', variant = 'primary', showText = false, className = '' }) {
  const cs = useCompanySettings();
  const h = size === 'xs' ? 28 : size === 'xl' ? 104 : size === 'lg' ? 72 : size === 'sm' ? 40 : 56;
  const src = variant === 'compact' ? compactLogoSrc(cs) : logoSrc(cs);
  // Grayscale compact is designed for dark bg — no filter needed. Primary logo has red mark, keep contrast filter.
  const imgFilter = variant === 'compact' ? 'none' : 'invert(1) hue-rotate(180deg) contrast(1.05)';
  return (
    <div
      className={`inline-flex items-center gap-3 rounded-md bg-black border border-neutral-800 px-2 py-1.5 ${className}`}
      data-testid={`ca-logo-${variant}`}
    >
      <img
        src={src}
        alt="C&A Transporte & Rescate"
        style={{ height: h, filter: imgFilter }}
        className="object-contain"
      />
      {showText && (
        <div className="leading-none">
          <div className="font-display font-black text-white tracking-tight text-xs">
            TRANSPORTE &amp; RESCATE
          </div>
        </div>
      )}
    </div>
  );
}

// Kept for backwards compatibility with any legacy import
export { logoSrc as LOGO_URL };
